import { useState } from "react";
import { Title } from "../../../components";
import { Container } from "./styles";

function BKSemContraste(){
    return (
        <Container>
            <div className="row">
                <div className="col">
                    <Title>Back-up</Title>
                    <section className="mt-2 p-3">

                        <ul>
                            <li>Scout;</li>
                            <li>Axial mediastino</li>
                            <li>Coronal mediastino</li>
                            <li>Sagital mediastino</li>
                            <li>Axial Pulmão</li>
                            <li>Coronal Pulmão</li>
                            <li>Sagital Pulmão</li>
                            <li>Axial alta resolução</li>
                            <li>Axial MIP</li>
                            <li>Coronal MIP</li>
                            <li>Coronal Min IP</li>
                            <li>3D Pulmões</li>
                            <li>Relatório de dose</li>
                        </ul>
                    </section>

                </div>
            </div>
        </Container>
    )
}

function BKContraste(){
    return (
        <Container>
            <div className="row">
                <div className="col">
                    <Title>Back-up</Title>
                    <section className="mt-2 p-3">

                        <ul>
                            <li>Scout;</li>
                            <li>Axial Mediastino S/C;</li>
                            <li>Coronal Mediastino S/C;</li>
                            <li>Sagital Mediastino S/C;</li>
                            <li>Axial Mediastino C/C;</li>
                            <li>Coronal Mediastino C/C;</li>
                            <li>Sagital Mediastino C/C;</li>
                            <li>Axial Pulmão;</li>
                            <li>Coronal Pulmão;</li>
                            <li>Sagital Pulmão;</li>
                            <li>Axial alta resolução</li>
                            <li>Axial MIP</li>
                            <li>Coronal MIP</li>
                            <li>Coronal Min IP</li>
                            <li>3D Pulmões</li>
                            <li>Relatório de Dose</li>
                        </ul>
                    </section>

                </div>
            </div>
        </Container>
    )
}

export default function BackUp(){
    const [contraste, setContraste] = useState(null)

    if(contraste === true){
        return BKContraste()
    }else if (contraste === false){
        return BKSemContraste()
    }else{
        return (
            <Container>
                <div className="row justify-content-center">
                    <div className="col-10 text-center">
                        <Title>Escolha uma opção</Title>
    
                        <button
                            className="btn btn-info btn-block"
                            onClick={() => {
                                setContraste(true)
                            }}
                        >Com Contraste I.V.</button>
    
                        <button
                            className="btn btn-info btn-block"
                            onClick={() => {
                                setContraste(false)
                            }}
                        >Sem Contraste I.V.</button>
                    </div>
                </div>
            </Container>
        )
    }   
}